import { t } from "../../i18n";
import { resolveFallback } from "./seoFallback";
import { SeoFallbackInputsType, SeoFallbackSource, SeoField } from "./seoTypes";

interface SeoFieldFallbackProps {
  field: SeoField;
  fallbackInputs: SeoFallbackInputsType;
  /** Left out for a target that has no CMS SEO, so no override hint is shown. */
  cmsAvailable?: boolean;
  testId: string;
}

function sourceLabel(source: SeoFallbackSource): string {
  switch (source) {
    case "tabCms":
      return t("admin.seo.source.tab-strapi", undefined, "tab Strapi");
    case "pageCms":
      return t("admin.seo.source.page-strapi", undefined, "page Strapi");
    case "game":
      return t("admin.seo.source.game", undefined, "game");
    case "default":
      return t("admin.seo.source.default", undefined, "default");
  }
}

/** What an empty field will show instead, and where that value comes from. */
export function SeoFieldFallback({ field, fallbackInputs, cmsAvailable, testId }: SeoFieldFallbackProps): JSX.Element {
  const fallback = resolveFallback(field, fallbackInputs);
  return (
    <small
      className="form-text text-muted"
      data-testid={testId}
    >
      {fallback === undefined
        ? t("admin.seo.fallback.will-show-nothing", undefined, "Will show: nothing")
        : t(
            "admin.seo.fallback.will-show",
            // React escapes the rendered text itself; i18next escaping on top would show a URL's "&" as "&amp;".
            { value: fallback.value, source: sourceLabel(fallback.source), interpolation: { escapeValue: false } },
            "Will show: {{value}} (from {{source}})",
          )}
      {cmsAvailable === false && (
        <span data-testid={`${testId}-strapi-hint`}>
          {" · "}
          {t("admin.seo.strapi-may-override", undefined, "Strapi SEO may override this")}
        </span>
      )}
    </small>
  );
}
